import { translate } from "@/i18n/translate";

export type OrderStatusValue = string | number | boolean | null | undefined;

export function formatOrderStatus(status: OrderStatusValue): string {
  if (status === null || status === undefined || status === "") {
    return translate("common.notAvailable");
  }

  return String(status);
}
